<div class="assistant-wrapper">
    @if (chatStarted()) {
        <div class="chat-messages" #chatMessages role="log" aria-label="chat messages">
            @for (message of messages(); track $index; let msgIndex = $index) {
                <div [attr.data-sender]="message.sender">
                    <span>{{message.text}}</span>
                </div>
                @if (message.policies) {
                    @for (policy of message.policies; track $index) {
                        <div class="bot-rule">
                            <mon-bot-view-policy [botViewPolicy]="policy" (viewPolicy)="onViewPolicy($event)"></mon-bot-view-policy>
                        </div>
                        <mon-evaluation-widget class="mb-2" (choice)="onFeedbackChoiceSelected($event, msgIndex)"></mon-evaluation-widget>
                    }
                }
                @if (message.category === 'prompt-restart-conversation' && !message.promptSelected) {
                    <div class="prompt-restart-buttons-container">
                        <button #restartConversationButton
                                type="button"
                                class="btn opt-button opt-button-main mr-2"
                                (click)="confirmRestartConversation()">Yes, start a new chat</button>
                        <button type="button"
                                class="btn opt-button opt-button-secondary"
                                (click)="cancelRestartConversation(msgIndex)">No, don't clear this chat</button>
                    </div>
                }
            }
            @if (messageBeingProcessed()) {
                <div [attr.data-sender]="'bot'">
                    <div role="status" class="spinner-border spinner-border-sm text-secondary">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            }
        </div>
    } @else {
        <mon-bot-greetings
            [hasUserAgreement]="hasUserAgreement()"
            [userAuthenticated]="userAuthenticated()"
            (userAgreed)="onUserAgreed()"></mon-bot-greetings>
        @if (userAuthenticated()) {
            <mon-bot-suggestions (select)="onSuggestionSelected($event)"></mon-bot-suggestions>
        }
    }
    @let conversationRestartable = chatStarted() && !isPromptingRestartConversation() && !messageBeingProcessed();
    @if (userAuthenticated()) {
        <div class="text-input-wrapper">
            <form (submit)="onTextSubmit($event)">
                <textarea
                    placeholder="Message Policy Assistant"
                    #userText
                    (change)="onTextInput()"
                    (keyup)="onTextInput()"></textarea>
                <button type="submit"
                    class="submit-user-input"
                    aria-label="Submit message"
                    [attr.aria-disabled]="messageBeingProcessed()"
                    >
                    <img src="/images/send-icon.svg" alt="">
                </button>
                <button type="button"
                    class="reset-conversation-button"
                    aria-label="Reset conversation"
                    ngbTooltip="Reset conversation"
                    [attr.aria-disabled]="!conversationRestartable"
                    (click)="conversationRestartable && promptRestartConversation()"
                    >
                    @if (conversationRestartable) {
                        <img src="/images/restart-active.svg" alt="">
                    } @else {
                        <img src="/images/restart-inactive.svg" alt="">
                    }
                </button>
                <span class="input-disclaimer" translate>The Policy Assistant runs on Google Vertex AI, which can make mistakes.</span>
            </form>
        </div>
    }
</div>
